import React, { useId } from "react";
import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";
import { License1cCalculator } from "./License1cCalculator";

export function LicenseCalculatorDrawer({ open, onClose }) {
  const titleId = useId();

  const close = () => onClose?.();

  return (
    <SideDrawer
      open={open}
      onClose={close}
      title="Калькулятор лицензий"
      titleId={titleId}
      toolbar={<SideDrawerCloseButton onClick={close} title="Закрыть" />}
    >
      <License1cCalculator active={open} variant="header" />
    </SideDrawer>
  );
}
